import {
  BoelsCatalogsResponse,
  BoelsCatalogVersion,
  BoelsGenericState,
} from '@boels/models';
import { createReducer, on } from '@ngrx/store';
import {
  loadCatalogs,
  loadCatalogsFail,
  loadCatalogsSuccess,
} from '../actions/catalogs.action';

export interface CatalogsState extends BoelsGenericState {
  entities: CatalogMap; // only online will be safed under the culture
  errorMessage?: string;
}

export interface CatalogMap {
  [cultureId: string]: BoelsCatalogVersion;
}

export const catalogsInitialState: CatalogsState = {
  entities: {},
  loading: false,
  success: false,
  error: false,
  errorMessage: undefined,
};

export const reducer = createReducer(
  catalogsInitialState,
  on(loadCatalogs, (state) => ({
    ...state,
    loading: true,
    success: false,
    error: false,
  })),
  on(loadCatalogsSuccess, (state, { catalogs, culture }) => {
    return {
      ...state,
      loading: false,
      success: true,
      error: false,
      entities: {
        ...state.entities,
        [culture]: getOnlineCatalog(catalogs), // only add online catalog to state
      },
    };
  }),
  on(loadCatalogsFail, (state, { errorMessage }) => ({
    ...state,
    error: true,
    loading: false,
    success: false,
    errorMessage,
  })),
);

function getOnlineCatalog(
  catalogs: BoelsCatalogsResponse,
): BoelsCatalogVersion {
  const result = catalogs.catalogs
    ?.find((catalog) => catalog?.id?.endsWith('ProductCatalog'))
    ?.catalogVersions?.find(
      (catalogVersion) => catalogVersion.id === 'Online',
    ) as BoelsCatalogVersion; // only add online catalog to state

  return result;
}
